import { render, staticRenderFns } from "./TeamMembersTable.vue?vue&type=template&id=288f2520&"
import script from "./TeamMembersTable.vue?vue&type=script&lang=js&"
export * from "./TeamMembersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports